import { createWebHistory, createRouter } from "vue-router";
import axios from 'axios';
import routes from './routes';
import appConfig from "../../app.config";
import store from '@/state/store';
import apiClient from "../libs/axios";

const router = createRouter({
  history: createWebHistory(),
  routes,
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: 'history',
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0 };
    }
  },
});

// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
// function nextFactory(context, middleware, index) {
//   const subsequentMiddleware = middleware[index];
//   // If no subsequent Middleware exists,
//   // the default `next()` callback is returned.
//   if (!subsequentMiddleware) return context.next;
//
//   return (...parameters) => {
//     // Run the default Vue Router `next()` callback first.
//     context.next(...parameters);
//     // Then run the subsequent Middleware with a new
//     // `nextMiddleware()` callback.
//     const nextMiddleware = nextFactory(context, middleware, index + 1);
//     subsequentMiddleware({...context, next: nextMiddleware});
//   };
// }

// router.beforeResolve(async (to, from, next) => {
//   const languages = ['ar', 'en'];
//   if (languages.includes(to.params.lang)) {
//     // localize(to.params.lang);
//     // wameedLang(to.params.lang);
//     moment.locale(to.params.lang); // 'en'
//
//     store.commit('TOGGLE_RTL', to.params.lang);
//     await store.dispatch('setCurrentLocale', to.params.lang);
//
//     i18n.locale = to.params.lang;
//
//     if (to.meta.permissions) {
//
//       if (store.getters['profile/getPermissions'].length === 0) {
//         await store.dispatch('profile/basic')
//       }
//       if (!store.getters['profile/getPermissions'].some((value) => to.meta.permissions.includes(value))) {
//         next({name: 'dashboard', params: {lang: i18n.locale}});
//       }
//     }
//     if (to.meta.middleware) {
//       const middleware = Array.isArray(to.meta.middleware)
//           ? to.meta.middleware
//           : [to.meta.middleware];
//
//       const context = {
//         from,
//         next,
//         router,
//         to,
//       };
//       const nextMiddleware = nextFactory(context, middleware, 1);
//
//       return middleware[0]({...context, next: nextMiddleware});
//     }
//     return next();
//   } else {
//     if (to.name) next({name: to.name, params: {lang: i18n.locale}});
//     else next({name: 'dashboard', params: {lang: i18n.locale}});
//   }
// });

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
// router.afterEach((to) => {
//   // Remove initial loading
//   const appLoading = document.getElementById('loading-bg');
//   if (appLoading) {
//     appLoading.style.display = 'none';
//   }
//
//   if (to.meta.pagePermissions) {
//
//     if (to.meta.pagePermissions.create && !store.getters['profile/getPermissions'].includes(to.meta.pagePermissions.create)) {
//       removeElementsFromDom('button-header-create');
//     }
//
//     if (to.meta.pagePermissions.read && !store.getters['profile/getPermissions'].includes(to.meta.pagePermissions.read)) {
//       removeElementsFromDom('permission-show-detail');
//     }
//
//     if (to.meta.pagePermissions.delete && !store.getters['profile/getPermissions'].includes(to.meta.pagePermissions.delete)) {
//       removeElementsFromDom('permission-delete-item');
//     }
//
//     if (to.meta.pagePermissions.edit && !store.getters['profile/getPermissions'].includes(to.meta.pagePermissions.edit)) {
//       removeElementsFromDom('permission-edit-item');
//     }
//
//
//   }
//
//
// });
//
// export function removeElementsFromDom(className) {
//   setTimeout(() => {
//     let elements = document.getElementsByClassName(className)
//     elements.forEach((el) => {
//       el.parentNode.removeChild(el)
//     })
//   }, 0)
// }

// API based Authentication
// Before each route evaluates...
router.beforeEach(async (routeTo, routeFrom, next) => {

  const authRequired = routeTo.matched.some((route) => route.meta.authRequired);

  if (!authRequired) return next();

  const userData = JSON.parse(localStorage.getItem('user'));
  axios.defaults.headers.common['authorization'] = 'Bearer ' + userData?.token; // for all requests
  console.log(axios.defaults.headers);
  await apiClient.get('api/v1/profile').then((data) => {
    localStorage.setItem('user-data', JSON.stringify(data.data.result));
    next();
  }).catch(() => {
    next({ name: 'login', query: { redirectFrom: routeTo.fullPath } });
  });
});

router.beforeEach((routeTo, routeFrom, next) => {
  if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {

    // Check if auth is required on this route
    // (including nested routes).
    const authRequired = routeTo.matched.some((route) => route.meta.authRequired);

    // If auth isn't required for the route, just continue.
    if (!authRequired) return next();

    // If auth is required and the user is logged in...
    if (store.getters['auth/loggedIn']) {
      // Validate the local user token...
      return store.dispatch('auth/validate').then((validUser) => {
        // Then continue if the token still represents a valid user,
        // otherwise redirect to login.
        validUser ? next() : redirectToLogin();
      });
    }

    // If auth is required and the user is NOT currently logged in,
    // redirect to login.
    redirectToLogin();

    // eslint-disable-next-line no-unused-vars
    // eslint-disable-next-line no-inner-declarations
    function redirectToLogin() {
      // Pass the original route to the login component
      next({ name: 'login', query: { redirectFrom: routeTo.fullPath } });
    }
  } else {
    const publicPages = ['/login', '/register', '/forgot-password'];
    const authpage = !publicPages.includes(routeTo.path);
    const loggeduser = localStorage.getItem('user');

    if (authpage && !loggeduser) {
      return next('/login');
    }

    next();
  }
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
  // Create a `beforeResolve` hook, which fires whenever
  // `beforeRouteEnter` and `beforeRouteUpdate` would. This
  // allows us to ensure data is fetched even when params change,
  // but the resolved route does not. We put it in `meta` to
  // indicate that it's a hook we created, rather than part of
  // Vue Router (yet?).
  try {
    // For each matched route...
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            // If the user chose to redirect...
            if (args.length) {
              // If redirecting to the same route we're coming from...
              // Complete the redirect.
              next(...args);
              reject(new Error('Redirected'));
            } else {
              resolve();
            }
          });
        } else {
          // Otherwise, continue resolving the route.
          resolve();
        }
      });
    }
    // ** التحقق من الأدوار **
    if (routeTo.meta.roles) {
      if (store.getters['profile/profile/getRoles'].length === 0) {
        await store.dispatch('profile/profile/basic')
      }
      const userRole = getCurrentUserRoles();
      const allowedRoles = routeTo.meta.roles;

      if (!allowedRoles.some(role => userRole.includes(role))) {
        console.log(userRole);
        return next('/dashboard');
      }
    }
    // If a `beforeResolve` hook chose to redirect, just return.
  } catch (error) {
    console.error('Navigation error:', error);
    return;
  }
  document.title = routeTo.meta.title + ' | ' + appConfig.title;
  // If we reach this point, continue resolving the route.
  next();
});

function getCurrentUserRoles() {
  return store.getters['profile/profile/getRoles'];
}

export default router;
